import {
  Card,
  Input,
  Grid,
  Button,
  Spinner,
  Tooltip,
} from '@enterprise-ui/canvas-ui-react'
import { Autocomplete } from '@enterprise-ui/canvas-ui-react-autocomplete'
import {
  BULK_DOWNLOAD_TOOLTIP,
  BULK_UPDATE,
} from '../../../constants/bulkUtilitiesConstants'
import EnterpriseIcon, { DownloadIcon } from '@enterprise-ui/icons'
import { useExport } from './useExport'

const DownloadItemView = () => {
  const {
    selectedValues,
    handlePurposeChange,
    loadingIntendedUse,
    indendedUses,
    handleIntendedUseChange,
    loadingItemType,
    itemTypes,
    handleItemTypeChange,
    downloadButtonState,
    handleBulkExport,
    isItemTypeDisabled,
    isNoItemsAvailable,
  } = useExport()

  const isDisabled =
    downloadButtonState.disabled || downloadButtonState?.inProgress

  const buttonContent = downloadButtonState?.inProgress ? (
    <div role="alert" aria-live="assertive" aria-busy="true">
      <Spinner
        size="dense"
        className="hc-mr-dense"
        aria-label="File is processing, please wait"
      />
      <span aria-hidden="true" className="file-processing-btn">
        File Processing
      </span>
    </div>
  ) : (
    <>
      <EnterpriseIcon icon={DownloadIcon} className="hc-mr-min" />
      Download
    </>
  )

  const button = (
    <Button
      id="btn_download_items_excel"
      type="secondary"
      disabled={isDisabled}
      onClick={handleBulkExport}
      aria-label="Download spreadsheet in .xlsx format"
    >
      {buttonContent}
    </Button>
  )

  return (
    <Card id="card-download" className="hc-pa-normal">
      <h2 className="hc-pt-dense hc-fs-md font-weight-500">
        {BULK_UPDATE.EXPORT_ITEM.EXPORT_TITLE}
      </h2>
      {/* 1. Download options */}
      <Input.Radio
        className="hc-pv-dense"
        options={BULK_UPDATE.EXPORT_ITEM.EXPORT_OPTIONS.map(
          (option, index) => ({
            value: option.value,
            label: option.displayName,
          }),
        )}
        value={selectedValues?.purpose}
        onUpdate={(id, value) => handlePurposeChange(value)}
      />

      {/* 2. Intended use */}
      {selectedValues.purpose === 'all' && (
        <Grid.Container className="hc-mt-min">
          <Grid.Item xs={7}>
            <Input.Label className="hc-fs-xs" htmlFor="select_intended_use">
              Intended use
            </Input.Label>
            <Input.Select
              id="select_intended_use"
              disabled={loadingIntendedUse}
              placeholder={BULK_UPDATE.EXPORT_ITEM.PLACEHOLDER_INTENDED_USE}
              options={loadingIntendedUse ? [] : indendedUses}
              onUpdate={(id, value) => handleIntendedUseChange(value)}
              value={selectedValues?.intendedUse}
            />
          </Grid.Item>
          {loadingIntendedUse && (
            <Grid.Item xs={1} className="hc-pt-xl">
              <Spinner />
            </Grid.Item>
          )}
        </Grid.Container>
      )}

      {/* 3. Item type */}
      <Grid.Container className="hc-mt-dense">
        <Grid.Item xs={loadingItemType ? 4 : 5}>
          <Input.Label className="hc-fs-xs" htmlFor="select_item_type">
            Item type
          </Input.Label>
          <Autocomplete
            id="select_item_type"
            disabled={isItemTypeDisabled() || loadingItemType}
            placeholder={BULK_UPDATE.EXPORT_ITEM.PLACEHOLDER_ITEM_TYPE}
            options={
              loadingItemType ||
              (selectedValues?.purpose === 'all' &&
                !selectedValues?.intendedUse)
                ? []
                : itemTypes
            }
            onUpdate={(id, value) => handleItemTypeChange(value)}
            value={selectedValues?.itemType}
          />
        </Grid.Item>
        {loadingItemType && (
          <Grid.Item xs={1} className="hc-pt-xl">
            <div role="alert" aria-live="assertive" aria-busy="true">
              <Spinner
                size="dense"
                className="hc-mr-dense"
                aria-label="Loading item types, please wait"
              />
            </div>
          </Grid.Item>
        )}
        <Grid.Item xs={3} className="align-content-end">
          <Tooltip
            content={
              isNoItemsAvailable
                ? BULK_DOWNLOAD_TOOLTIP.NO_ITEMS_MESSAGE
                : BULK_DOWNLOAD_TOOLTIP.TEMPLATE_DEFAULT_MESSAGE
            }
            location="right"
          >
            {button}
          </Tooltip>
        </Grid.Item>
      </Grid.Container>
    </Card>
  )
}

export default DownloadItemView
